import React from "react";
import { useSelector } from "react-redux";
import Tipo from "./Tipo";

export default function ListaTiposAsistencia() {
  const { tiposAsistencia } = useSelector(
    (state) => state.tiposAsistenciaReducer
  );

  return (
    <>
      <div style={{ textAlign: "center", marginBottom: 10 }}>
        Tipos de Asistencia
      </div>
      {tiposAsistencia.map((t, i) => (
        <Tipo key={i} tipo={t} />
      ))}
    </>
  );
}
